/** @format */

import React from "react";
import { Alert, Badge } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { useGetForUserQuery } from "../../../app/services/userResourceApi";
import { useLocale } from "../../../i18n/hooks";

type Props = {
  className?: string;
}

const MyResourcesCount: React.FC<Props> = ({ className }) => {
  const { t: _ } = useTranslation(undefined, { keyPrefix: "myResources" });
  const locale = useLocale();
  const { pathname } = useLocation();

  const { data } = useGetForUserQuery();

  const englishResources = data?.filter((resource) => resource.Locale === "en");
  const welshResources = data?.filter((resource) => resource.Locale === "cy");

  return (
    <Alert variant="info" className={className}>
      <table>
        <tbody>
          <tr>
            <td className="pe-3">{locale === "en" && <strong>&gt;</strong>}</td>
            <td className="w-100">
              {locale === "en" ? (
                <strong><Link to={pathname.replace('cy', 'en')}>{_("englishResources")}</Link></strong>
              ) : (
                <Link to={pathname.replace('cy', 'en')}>{_("englishResources")}</Link>
              )}{" "}
            </td>
            <td>
              <Badge className="ms-2" bg="secondary">
                {englishResources?.length}
              </Badge>
            </td>
          </tr>
          <tr>
            <td className="pe-3">{locale === "cy" && <strong>&gt;</strong>}</td>
            <td className="w-100">
              {locale === "cy" ? (
                <strong><Link to={pathname.replace('en', 'cy')}>{_("welshResources")}</Link></strong>
              ) : (
                <Link to={pathname.replace('en', 'cy')}>{_("welshResources")}</Link>
              )}{" "}
            </td>
            <td>
              <Badge className="ms-2" bg="secondary">
                {welshResources?.length}
              </Badge>
            </td>
          </tr>
        </tbody>
      </table>
    </Alert>
  );
};

export default MyResourcesCount;
